var map = {
	"./affaere1/delete-grey-button.svg": 31933,
	"./affaerentreff/delete-grey-button.svg": 27455,
	"./casualxdates/delete-grey-button.svg": 46810,
	"./delete-grey-button.svg": 96539,
	"./ficktreffpunkt24/delete-grey-button.svg": 15952,
	"./fremdgehboerse/delete-grey-button.svg": 74008,
	"./illicitoasis/delete-grey-button.svg": 2301,
	"./seitensprungtreff69/delete-grey-button.svg": 68693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77067;